import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { safePaymentUrl } from '../lib/entitlements';

// Ürün sahibi kararı: "Premium ol" tıklanınca doğrudan ana yöneticinin girdiği bağlantı yeni sekmede açılır.
// Bağlantı yoksa mevcut talep akışına (ProRequest) gider. `paymentUrl` verilmezse bağlantı burada okunur.
export const usePaymentUrl = (enabled = true) => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    Promise.resolve(axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/membership/payment-info`))
      .then(response => { if (active) setUrl(safePaymentUrl(response?.data?.payment_url)); })
      .catch(() => {});
    return () => { active = false; };
  }, [enabled]);
  return url;
};

export default function PremiumCta({ paymentUrl, fallback = '/pro#pro-request', className = 'action-primary', testId = 'premium-cta' }) {
  const fetched = usePaymentUrl(paymentUrl === undefined);
  const url = paymentUrl === undefined ? fetched : safePaymentUrl(paymentUrl);
  if (url) return <a href={url} target="_blank" rel="noopener noreferrer" className={className} data-testid={testId}>Premium ol</a>;
  if (fallback.startsWith('#')) return <a href={fallback} className={className} data-testid={testId}>Premium ol</a>;
  return <Link to={fallback} className={className} data-testid={testId}>Premium ol</Link>;
}
